import React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import drive from '../../assets/images/drive.svg'
import oneDrive from '../../assets/images/oneDrive.svg'
import postgress from '../../assets/images/postgress.svg'
import mssql from '../../assets/images/mssql.svg'
import mysql from '../../assets/images/mysql.svg'
import './ConnectDB.css'

function ConnectDB() {
    const steps = [
        {
            id: 1,
            title: "1. Choose connector.",
            img: "/images/step1.png", // replace with real image path
            alt: "Step 1",
        },
        {
            id: 2,
            title: "2. Authorize securely.",
            img: "/images/step2.png",
            alt: "Step 2",
        },
        {
            id: 3,
            title: "3. Test & save.",
            img: "/images/step3.png",
            alt: "Step 3",
        },
    ];
    const capabilities = [
        { icon: "🔒", text: "SOC II Type 2" },
        { icon: "✅", text: "SSO, 2FA, scoped access" },
        { icon: "🔐", text: "Secure OAuth / API token flows" }

    ];
    return (
        <div className="home">
            <Header />
            <div className='banner-section d-flex flex-column align-items-center justify-content-center ' style={{ gap: '24px' }}>
                <h1 className="banner-title w-50">Connect in Seconds. Query at Scale.</h1>
                <p className="banner-description">
                    From files to warehouses, BrainyAgent links your sources securely and instantly. No heavy setup required.
                </p>
                <div className='d-flex gap-3'>
                    <button className="theme-rounded-btn" style={{ padding: '16px 24px' }}>Build Your First Chart</button>
                </div>
            </div>
            <div className='cards-section'>
                <h3 style={{ fontSize: '45px' }}>Popular Connectors</h3>
                <div className='d-flex gap-24 w-100 card-container'>
                    <div className='card-pill gap-3 rounded-pill'>
                        <img src={drive} alt="" />
                        <p className='m-0'>Google Drive</p>
                    </div>
                    <div className='card-pill gap-3 rounded-pill'>
                        <img src={oneDrive} alt="" />
                        <p className='m-0'>OneDrive</p>
                    </div>
                </div>
                <div className='d-flex gap-24 w-100 card-container'>
                    <div className='card-pill gap-3 rounded-pill'>
                        <img src={postgress} alt="" />
                        <p className='m-0'>Postgres</p>
                    </div>
                    <div className='card-pill gap-3 rounded-pill'>
                        <img src={mssql} alt="" />
                        <p className='m-0'>MSSQL</p>
                    </div>
                    <div className='card-pill gap-3 rounded-pill'>
                        <img src={mysql} alt="" />
                        <p className='m-0'>MySQL</p>
                    </div>
                </div>
            </div>
            <div className="card-frame d-flex flex-column w-100"
                style={{ padding: "64px 200px", gap: "48px" }}
            >
                <h3>Connection Flow</h3>
                <div className="row w-100">
                    {steps.map((step) => (
                        <div key={step.id} className="col-12 col-md-4 p-3">
                            <div className="card h-100 shadow-sm d-flex flex-column justify-content-between rounded-4 overflow-hidden p-3">
                                <div className="card-body p-0 mb-2">
                                    <h5 className="fw-bold">{step.title}</h5>
                                </div>
                                <div className="text-center w-100 border rounded-4" style={{height:'200px',background:"#D9D9D9"}}>
                                    {/* <img
                                        src={step.img}
                                        alt={step.alt}
                                        className="img-fluid w-100 rounded-bottom-4"
                                    /> */}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="card-frame w-100 d-flex flex-column" style={{ padding: '64px 200px', gap: '48px' }}>
                <h3>Security First</h3>
                <div className="capabilities-grid" style={{gap:'16px'}}>
                    {capabilities.map((cap, i) => (
                        <div key={i} className="capability-card gap-3" style={{background:'#EDF1F5'}}>
                            <span className="icon">{cap.icon}</span>
                            <span style={{color:'#000000'}}>{cap.text}</span>
                        </div>
                    ))}
                </div>
            </div>
            <div className='banner-section d-flex flex-column align-items-start justify-content-start ' style={{ gap: '24px', padding: '64px 200px' }}>
                <h1 className="banner-title text-start w-75" style={{fontSize:'45px'}}>Get started in seconds.</h1>
                <p className="banner-description text-start w-100">
                    Securely connect your first data source and start asking questions right away.
                </p>
                <div className='d-flex gap-3'>
                    <button className="theme-rounded-btn" style={{ padding: '16px 24px' }}>Connect Data Source</button>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default ConnectDB